import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

const LastUpdatedIndicator = ({ lastUpdated, onRefresh, loading = false }) => {
    const [relativeTime, setRelativeTime] = useState('');

    useEffect(() => {
        const updateRelativeTime = () => {
            if (!lastUpdated) {
                setRelativeTime('Never');
                return;
            }

            const seconds = Math.floor((Date.now() - lastUpdated) / 1000);

            if (seconds < 5) {
                setRelativeTime('Just now');
            } else if (seconds < 60) {
                setRelativeTime(`${seconds}s ago`);
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                setRelativeTime(`${minutes}m ago`);
            } else if (seconds < 86400) {
                const hours = Math.floor(seconds / 3600);
                setRelativeTime(`${hours}h ago`);
            } else {
                const days = Math.floor(seconds / 86400);
                setRelativeTime(`${days}d ago`);
            }
        };

        updateRelativeTime();
        const interval = setInterval(updateRelativeTime, 1000);
        return () => clearInterval(interval);
    }, [lastUpdated]);

    return (
        <div className="flex items-center gap-2 text-sm text-gray-600">
            <span className="flex items-center gap-1">
                <span className="text-gray-500">Last updated:</span>
                <span className="font-medium text-gray-700">{relativeTime}</span>
            </span>
            {onRefresh && (
                <button
                    onClick={onRefresh}
                    disabled={loading}
                    className={`p-1 hover:bg-gray-100 rounded transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    title="Refresh now"
                >
                    <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
                </button>
            )}
        </div>
    );
};

export default LastUpdatedIndicator;
